import { render } from "./NotionIntegration.vue?vue&type=template&id=221e0eaf"
import script from "./NotionIntegration.vue?vue&type=script&lang=js"
export * from "./NotionIntegration.vue?vue&type=script&lang=js"

import exportComponent from "/Users/xianbinlin/workplace/work/projects/notionWeb/app-notion2web/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])